var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-radio",class:{
    'is-inline': _vm.inline
  }},[_c('input',_vm._b({staticClass:"input",attrs:{"id":_vm.id,"type":"radio"},domProps:{"checked":_vm.checked,"value":_vm.value},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_c('label',{staticClass:"label",attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }